export default __webpack_public_path__ + "static/media/Drier-with-coil.d3aa2707.jpg";